import dhtmlXGridObject from './dhtmlXGridObject';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';

(function () {
    function g(m, n) {

        this[m] = n;
    }
    function l(m, n) {

        this[m].call(this, n);
    }
    function e(m, n) {

        this[m].call(this, n.join(this.delim));
    }
    function a(m, r) {
        for (var o = 0; o < r.length; o++) {
            if (typeof r[o] == "object") {

                var s = this.getCombo(o);
                for (var n in r[o]) {
                    s.put(n, r[o][n]);
                }
            }
        }
    }
    function h(m, w) {
        var v = [];
        function x(C, A, D) {
            if (!v[A]) {
                v[A] = [];
            }
            if (typeof D == "object") {
                D.toString = function () {
                    return this.text;
                };
            }
            v[A][C] = D;
        }
        for (var s_1 = 0; s_1 < w.length; s_1++) {
            if (typeof w[s_1] == "object" && w[s_1].length) {
                for (var o = 0; o < w[s_1].length; o++) {
                    x(s_1, o, w[s_1][o]);
                }
            }
            else {
                x(s_1, 0, w[s_1]);
            }
        }
        for (var s_2 = 0; s_2 < v.length; s_2++) {
            for (var od = 0; od < v[0].length; od++) {
                var u = v[s_2][od];
                v[s_2][od] = (u || "").toString() || "&nbsp;";
                if (u && u.colspan) {
                    for (var n = 1; n < u.colspan; n++) {
                        x(od + n, s_2, "#cspan");
                    }
                }
                if (u && u.rowspan) {
                    for (var n_1 = 1; n_1 < u.rowspan; n_1++) {
                        x(od, s_2 + n_1, "#rspan");
                    }
                }
            }
        }

        this.setHeader(v[0]);
        for (var s = 1; s < v.length; s++) {

            this.attachHeader(v[s]);
        }
    }
    var c = [
        { name: "label", def: "&nbsp;", operation: "setHeader", type: h },
        {
            name: "id",
            def: "",
            operation: "columnIds",
            type: g
        },
        { name: "width", def: "*", operation: "setInitWidths", type: e },
        {
            name: "align",
            def: "left",
            operation: "cellAlign",
            type: g
        },
        { name: "valign", def: "middle", operation: "cellVAlign", type: g },
        {
            name: "sort",
            def: "na",
            operation: "fldSort",
            type: g
        },
        { name: "type", def: "ro", operation: "setColTypes", type: e },
        { name: "options", def: "", operation: "", type: a }
    ];
    dhtmlx.extend_api("dhtmlXGridObject", {
        _init: function (m) {
            return [m.parent];
        },
        image_path: "setImagePath",
        columns: "columns",
        rows: "rows",
        headers: "headers",
        skin: "setSkin",
        smart_rendering: "enableSmartRendering",
        css: "enableAlterCss",
        auto_height: "enableAutoHeight",
        save_hidden: "enableAutoHiddenColumnsSaving",
        save_cookie: "enableAutoSaving",
        save_size: "enableAutoSizeSaving",
        auto_width: "enableAutoWidth",
        block_selection: "enableBlockSelection",
        csv_id: "enableCSVAutoID",
        csv_header: "enableCSVHeader",
        cell_ids: "enableCellIds",
        colspan: "enableColSpan",
        column_move: "enableColumnMove",
        context_menu: "enableContextMenu",
        distributed: "enableDistributedParsing",
        drag: "enableDragAndDrop",
        drag_order: "enableDragOrder",
        tabulation: "enableEditTabOnly",
        header_images: "enableHeaderImages",
        header_menu: "enableHeaderMenu",
        keymap: "enableKeyboardSupport",
        mouse_navigation: "enableLightMouseNavigation",
        markers: "enableMarkedCells",
        math_editing: "enableMathEditing",
        math_serialization: "enableMathSerialization",
        drag_copy: "enableMercyDrag",
        multiline: "enableMultiline",
        multiselect: "enableMultiselect",
        save_column_order: "enableOrderSaving",
        hover: "enableRowsHover",
        rowspan: "enableRowspan",
        smart: "enableSmartRendering",
        save_sorting: "enableSortingSaving",
        stable_sorting: "enableStableSorting",
        undo: "enableUndoRedo",
        csv_cell: "setCSVDelimiter",
        date_format: "setDateFormat",
        drag_behavior: "setDragBehavior",
        editable: "setEditable",
        without_header: "setNoHeader",
        submit_changed: "submitOnlyChanged",
        submit_serialization: "submitSerialization",
        submit_selected: "submitOnlySelected",
        submit_id: "submitOnlyRowID",
        xml: "load"
    }, {
        columns: function (s) {
            for (var m = 0; m < c.length; m++) {
                var r = [];
                for (var n = 0; n < s.length; n++) {
                    r[n] = s[n][c[m].name] || c[m].def;
                }
                var o = c[m].type || l;
                o.call(this, c[m].operation, r, s);
            }
            this.init();
        },
        rows: function () { },
        headers: function (n) {
            for (var m = 0; m < n.length; m++) {
                this.attachHeader(n[m]);
            }
        }
    });
})();
dhtmlXGridObject.prototype._dp_init = function (a) {
    a.attachEvent("insertCallback", function (c, g) {

        if (this.obj._h2) {

            this.obj.addRow(g, e, null, parent);
        }
        else {

            this.obj.addRow(g, [], 0);
        }

        var e = this.obj.getRowById(g);
        if (e) {

            this.obj._process_xml_row(e, c.firstChild);

            this.obj._postRowProcessing(e);
        }
    });
    a.attachEvent("updateCallback", function (c, g) {

        var e = this.obj.getRowById(g);
        if (e) {

            this.obj._process_xml_row(e, c.firstChild);

            this.obj._postRowProcessing(e);
        }
    });
    a.attachEvent("deleteCallback", function (c, e) {

        this.obj.setUserData(e, this.action_param, "true_deleted");

        this.obj.deleteRow(e);
    });
    a._methods = [
        "setRowTextStyle",
        "setCellTextStyle",
        "changeRowId",
        "deleteRow"
    ];
    this.attachEvent("onEditCell", function (g, h, e) {
        if (a._columns && !a._columns[e]) {
            return true;
        }

        var c = this.cells(h, e);
        if (g == 1) {
            if (c.isCheckbox()) {
                a.setUpdated(h, true);
            }
        }
        else {
            if (g == 2) {
                if (c.wasChanged()) {
                    a.setUpdated(h, true);
                }
            }
        }
        return true;
    });
    this.attachEvent("onRowPaste", function (c) {
        a.setUpdated(c, true);
    });
    this.attachEvent("onUndo", function (c) {
        a.setUpdated(c, true);
    });
    this.attachEvent("onRowIdChange", function (g, c) {
        var e = a.findRow(g);
        if (e < a.updatedRows.length) {
            a.updatedRows[e] = c;
        }
    });
    this.attachEvent("onSelectStateChanged", function () {
        if (a.updateMode == "row") {
            a.sendData();
        }
        return true;
    });
    this.attachEvent("onEnter", function () {
        if (a.updateMode == "row") {
            a.sendData();
        }
        return true;
    });
    this.attachEvent("onBeforeRowDeleted", function (c) {

        if (a._silent_mode || !this.rowsAr[c]) {
            return true;
        }

        if (this.dragContext && a.dnd) {
            window.setTimeout(function () {
                a.setUpdated(c, true);
            }, 1);
            return true;
        }
        var e = a.getState(c);

        if (this._h2) {

            this._h2.forEachChild(c, function (g) {
                a.setUpdated(g.id, false);
                a.markRow(g.id, true, "deleted");

            }, this);
        }
        if (e == "inserted") {
            a.set_invalid(c, false);
            a.setUpdated(c, false);
            return true;
        }
        if (e == "deleted") {
            return false;
        }
        if (e == "true_deleted") {
            a.setUpdated(c, false);
            return true;
        }
        a.setUpdated(c, true, "deleted");
        return false;
    });
    this.attachEvent("onBindUpdate", function (e, c, g) {
        a.setUpdated(g, true);
    });
    this.attachEvent("onRowAdded", function (c) {

        if (this.dragContext && a.dnd) {
            return true;
        }
        a.setUpdated(c, true, "inserted");
        return true;
    });
    a._getRowData = function (g) {
        var m = [];
        m.gr_id = g;
        if (this.obj.isTreeGrid()) {
            m.gr_pid = this.obj.getParentId(g);
        }
        var e = this.obj.getRowById(g);
        var o = null;
        for (var n = 0; n < this.obj._cCount; n++) {
            if (this.obj._c_order) {
                o = this.obj._c_order[n];
            }
            else {
                o = n;
            }
            var s = this.obj.cells(e.idd, n);
            if (this._changed && !s.wasChanged()) {
                continue;
            }
            if (this._endnm) {
                m[this.obj.getColumnId(n)] = s.getValue();
            }
            else {
                m["c" + o] = s.getValue();
            }
        }
        var h = this.obj.UserData[g];
        if (h) {
            for (var l = 0; l < h.keys.length; l++) {
                if (h.keys[l] && h.keys[l].indexOf("__") != 0) {
                    m[h.keys[l]] = h.values[l];
                }
            }
        }
        h = this.obj.UserData.gridglobaluserdata;
        if (h) {
            for (var l_1 = 0; l_1 < h.keys.length; l_1++) {
                m[h.keys[l_1]] = h.values[l_1];
            }
        }
        return m;
    };
    a._clearUpdateFlag = function (e) {
        var g = this.obj.getRowById(e);
        if (g) {
            for (var c = 0; c < this.obj._cCount; c++) {
                this.obj.cells(e, c).cell.wasChanged = false;
            }
        }
    };
    a.checkBeforeUpdate = function (l) {
        var h = true;
        var c = [];
        for (var g = 0; g < this.obj._cCount; g++) {
            if (this.mandatoryFields[g]) {
                var e = this.mandatoryFields[g].call(this.obj, this.obj.cells(l, g).getValue(), l, g);
                if (typeof e == "string") {
                    this.messages.push(e);
                    h = false;
                }
                else {
                    h &= e;
                    c[g] = !e;
                }
            }
        }
        if (!h) {
            this.set_invalid(l, "invalid", c);
            this.setUpdated(l, false);
        }
        return h;
    };
};
dhx4.attachEvent("onGridCreated", function (c) {
    c._con_f_used = [].concat(c._con_f_used);
    dhtmlXGridObject.prototype._con_f_used = [];
    var a = function (l) {
        l = l.replace(/(\?|\&)connector[^\f]*/g, "");
        return (l +
            (l.indexOf("?") != -1 ? "&" : "?") +
            "connector=true" +

            (this.hdr.rows.length > 0 ? "&dhx_no_header=1" : ""));
    };
    var h = function (l) {

        return (a.call(this, l) +

            (this._connector_sorting || "") +

            (this._connector_filter || ""));
    };
    var g = function (m, n, l) {

        this._connector_sorting = "&dhx_sort[" + n + "]=" + l;

        return h.call(this, m);
    };
    var e = function (m, l, o) {
        var r = [];
        for (var n = 0; n < l.length; n++) {
            r[n] = "dhx_filter[" + l[n] + "]=" + encodeURIComponent(o[n]);
        }

        this._connector_filter = "&" + r.join("&");

        return h.call(this, m);
    };
    c.attachEvent("onCollectValues", function (l) {

        if (this._con_f_used[l]) {

            if (typeof this._con_f_used[l] == "object") {

                return this._con_f_used[l];
            }
            else {
                return false;
            }
        }
        return true;
    });
    c.attachEvent("onDynXLS", function () {

        if (this.xmlFileUrl) {

            this.xmlFileUrl = h.call(this, this.xmlFileUrl);
        }
        return true;
    });
    c.attachEvent("onBeforeSorting", function (o, n, m) {
        if (n == "connector") {

            var l = this;

            this.clearAndLoad(g.call(this, this.xmlFileUrl, o, m), function () {
                l.setSortImgState(true, o, m);
            });
            return false;
        }
        return true;
    });
    c.attachEvent("onFilterStart", function (m, l) {

        if (this._con_f_used.length) {

            var o = this.getSortingState();

            var n = this;

            this.clearAndLoad(e.call(this, this.xmlFileUrl, m, l));
            if (o.length) {
                n.setSortImgState(true, o[0], o[1]);
            }
            return false;
        }
        return true;
    });
});
dhtmlXGridObject.prototype._con_f_used = [];
dhtmlXGridObject.prototype._in_header_connector_text_filter = function (c, a) {
    if (!this._con_f_used[a]) {
        this._con_f_used[a] = 1;
    }
    return this._in_header_text_filter(c, a);
};
dhtmlXGridObject.prototype._in_header_connector_select_filter = function (c, a) {
    if (!this._con_f_used[a]) {
        this._con_f_used[a] = 2;
    }
    return this._in_header_select_filter(c, a);
};
if (!dhtmlXGridObject.prototype.load_connector) {
    dhtmlXGridObject.prototype.load_connector = dhtmlXGridObject.prototype.load;
    dhtmlXGridObject.prototype.load = function () {
        if (!this._colls_loaded && this.cellType) {
            var a = [];
            for (var e = 0; e < this.cellType.length; e++) {
                if (this.cellType[e].indexOf("co") == 0 ||
                    this.cellType[e].indexOf("clist") == 0 ||
                    this._con_f_used[e] == 2) {
                    a.push(e);
                }
            }
            if (a.length) {
                arguments[0] +=
                    (arguments[0].indexOf("?") != -1 ? "&" : "?") +
                        "connector=true&dhx_colls=" +
                        a.join(",");
            }
        }
        return this.load_connector.apply(this, arguments);
    };
    dhtmlXGridObject.prototype._parseHead_connector = dhtmlXGridObject.prototype._parseHead;
    dhtmlXGridObject.prototype._parseHead = function () {
        this._parseHead_connector.apply(this, arguments);
        if (!this._colls_loaded) {
            var s = dhx4.ajax.xpath("./coll_options", arguments[0]);
            for (var m = 0; m < s.length; m++) {
                var o = s[m].getAttribute("for");
                var u = [];
                var g = null;
                if (this.cellType[o] == "combo") {
                    g = this.getColumnCombo(o);
                }
                else {
                    if (this.cellType[o].indexOf("co") == 0) {
                        g = this.getCombo(o);
                    }
                }
                var l = dhx4.ajax.xpath("./item", s[m]);
                var a = [];
                for (var h = 0; h < l.length; h++) {
                    var e = l[h].getAttribute("value");
                    if (g) {
                        var n = l[h].getAttribute("label") || e;
                        if (g.addOption) {
                            a.push([e, n]);
                        }
                        else {
                            g.put(e, n);
                        }
                        u[u.length] = n;
                    }
                    else {
                        u[u.length] = e;
                    }
                }
                if (a.length) {
                    if (g) {
                        g.addOption(a);
                    }
                }
                else {
                    if (u.length && !g) {
                        if (this.registerCList) {
                            this.registerCList(o * 1, u);
                        }
                    }
                }
                if (this._con_f_used[o * 1]) {
                    this._con_f_used[o * 1] = u;
                }
            }
            this._colls_loaded = true;
        }
    };
}
// if (typeof window.dhtmlXCellObject != "undefined") {
//     dhtmlXCellObject.prototype.attachGrid = function () {
//         this.callEvent("_onBeforeContentAttach", ["grid"]);
//         var a = document.createElement("DIV");
//         a.style.width = "100%";
//         a.style.height = "100%";
//         a.style.position = "relative";
//         a.style.overflow = "hidden";
//         this._attachObject(a);
//         this.dataType = "grid";
//         this.dataObj = new dhtmlXGridObject(a);
//         this.dataObj.setSkin(this.conf.skin);
//         if (typeof window.dhtmlXTabBarCell == "function" &&
//             this instanceof window.dhtmlXTabBarCell &&
//             navigator.userAgent.match(/7[\.\d]* mobile/gi) != null &&
//             navigator.userAgent.match(/AppleWebKit/gi) != null) {
//             this.dataObj.objBox.style.webkitOverflowScrolling = "auto";
//         }
//         if (this.conf.skin == "material" &&
//             typeof window.dhtmlXLayoutCell == "function" &&
//             this instanceof window.dhtmlXLayoutCell) {
//             this.cell.childNodes[this.conf.idx.cont].style.overflow = "hidden";
//         }
//         if (this.conf.skin == "dhx_skyblue" &&
//             typeof window.dhtmlXWindowsCell == "function" &&
//             this instanceof window.dhtmlXWindowsCell) {
//             this.dataObj.entBox.style.border = "1px solid #a4bed4";
//             this.dataObj._sizeFix = 0;
//         }
//         else {
//             this.dataObj.entBox.style.border = "0px solid white";
//             this.dataObj._sizeFix = 2;
//         }
//         a = null;
//         this.callEvent("_onContentAttach", []);
//         return this.dataObj;
//     };
// }
dhtmlXGridObject.prototype.enableDragAndDrop = function (a) {
    if (a == "temporary_disabled") {
        this.dADTempOff = false;
        a = true;
    }
    else {
        this.dADTempOff = true;
    }
    this.dragAndDropOff = dhx4.s2b(a);
    this._drag_validate = true;
    if (a) {
        this.objBox.ondragstart = function (c) {
            (c || event).cancelBubble = true;
            return false;
        };
    }
};
dhtmlXGridObject.prototype.setDragBehavior = function (a) {
    this.dadmodec = this.dadmodefix = 0;
    switch (a) {
        case "child":
            this.dadmode = 0;
            this._sbmod = false;
            break;
        case "sibling":
            this.dadmode = 1;
            this._sbmod = false;
            break;
        case "sibling-next":
            this.dadmode = 1;
            this._sbmod = true;
            break;
        case "complex":
            this.dadmode = 2;
            this._sbmod = false;
            break;
        case "complex-next":
            this.dadmode = 2;
            this._sbmod = true;
            break;
    }
};
dhtmlXGridObject.prototype.enableDragOrder = function (a) {
    this._dndorder = dhx4.s2b(a);
};
dhtmlXGridObject.prototype._checkParent = function (g, c) {
    var e = this._h2.get[g.idd].parent;
    if (!e.parent) {
        return;
    }
    for (var a = 0; a < c.length; a++) {
        if (c[a] == e.id) {
            return true;
        }
    }
    return this._checkParent(this.rowsAr[e.id], c);
};
dhtmlXGridObject.prototype._createDragNode = function (g, h) {
    this.editStop();
    if (window.dhtmlDragAndDrop.dragNode) {
        return null;
    }
    if (!this.dADTempOff) {
        return null;
    }
    g.parentObject = new Object();
    g.parentObject.treeNod = this;
    var o = this.callEvent("onBeforeDrag", [g.parentNode.idd, g._cellIndex, h]);
    if (!o) {
        return null;
    }
    var l = new Array();
    l = this.getSelectedId();
    l = l && l != "" ? l.split(this.delim) : [];
    var m = false;
    for (var c = 0; c < l.length; c++) {
        if (l[c] == g.parentNode.idd) {
            m = true;
        }
    }
    if (!m) {
        this.selectRow(this.rowsAr[g.parentNode.idd], false, h.ctrlKey, false);
        if (!h.ctrlKey) {
            l = [];
        }
        l[this.selMultiRows ? l.length : 0] = g.parentNode.idd;
    }
    if (this.isTreeGrid()) {
        for (var c_1 = l.length - 1; c_1 >= 0; c_1--) {
            if (this._checkParent(this.rowsAr[l[c_1]], l)) {
                l.splice(c_1, 1);
            }
        }
    }
    var r = this;
    if (l.length && this._dndorder) {
        l.sort(function (s, e) {
            return r.rowsAr[s].rowIndex > r.rowsAr[e].rowIndex ? 1 : -1;
        });
    }
    var a = this.getFirstParentOfType(dhx4.isIE ? h.srcElement : h.target, "TD");
    if (a) {
        this._dndExtra = a._cellIndex;
    }
    this._dragged = new Array();
    for (var c_2 = 0; c_2 < l.length; c_2++) {
        if (this.rowsAr[l[c_2]]) {
            this._dragged[this._dragged.length] = this.rowsAr[l[c_2]];
            this.rowsAr[l[c_2]].treeNod = this;
        }
    }
    g.parentObject.parentNode = g.parentNode;
    var n = document.createElement("div");
    n.innerHTML = o !== true ? o : this.rowToDragElement(g.parentNode.idd);
    n.style.position = "absolute";
    n.className = "dragSpanDiv";
    return n;
};
dhtmlXGridObject.prototype._createSdrgc = function () {
    this._sdrgc = document.createElement("DIV");
    this._sdrgc.innerHTML = "&nbsp;";
    this._sdrgc.className = "gridDragLine";
    this.objBox.appendChild(this._sdrgc);
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dXGridObject/dxGridMethods000.js